<template>
  <div class="container">
    <!--搜索-->
    <search-filter :form-config="searchConfig" :model="query" @search="search" @reset="reset"></search-filter>
    <!--操作-->
    <el-button type="primary" plain size="small" round @click="handleAdd" style="margin-bottom:10px">新增隐患问题</el-button>
    <!--列表-->
    <el-table v-loading="loading" :data="tableData" 
      stripe border style="width: 100%">
      <el-table-column border label="序号" prop="id"></el-table-column>
      <el-table-column border label="场所类型" prop="site_type"></el-table-column>
      <el-table-column border label="项目编号1" prop="item1_code"></el-table-column>
      <el-table-column border label="检测内容" prop="item1_content"></el-table-column>
      <el-table-column border label="项目编号2" prop="item2_code"></el-table-column>
      <el-table-column border label="标准依据" prop="item2_content"></el-table-column>
      <el-table-column border label="隐患" prop="item2_trouble"></el-table-column>
      <el-table-column border label="隐患等级" prop="item2_level"></el-table-column>
      <el-table-column border label="整改建议" prop="item2_answer"></el-table-column>
      <el-table-column border label="操作" width="200px">
        <template slot-scope="scope">
          <el-button type="danger" plain size="small" round @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
      :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>

    <!--对话框-->
    <el-dialog title="新增隐患问题" :visible.sync="addModel.addShow" width="600px">
      <el-form ref="addForm" :model="addModel" label-width="80px" size="small">

        <el-form-item label="场所类型">
          <el-select v-model="addModel.site_type" placeholder="场所类型">
            <el-option label="出租屋" value="czw"></el-option>
            <el-option label="三小场所" value="sx"></el-option>
            <el-option label="其他场所" value="other"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目编号2">
          <el-input v-model="addModel.item2_code" placeholder="项目编号2"></el-input>
        </el-form-item>

        <el-form-item label="隐患问题">
          <el-input v-model="addModel.item2_trouble" placeholder="隐患"></el-input>
        </el-form-item>

        <el-form-item label="整改建议">
          <el-input v-model="addModel.item2_answer" placeholder="隐患等级"></el-input>
        </el-form-item>
        <el-form-item label="隐患等级">
          <el-select v-model="addModel.item2_level" placeholder="场所类型">
            <el-option label="A" value="A"></el-option>
            <el-option label="B" value="B"></el-option>
            <el-option label="C" value="C"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-left:80px;margin-top: 30px">
          <el-button type="primary" @click="onAdd">新增</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      pagination: { current_page: 1, total: 1, per_page: 10, },
      query: { site_type: "", item1_code: "", item1_content: "", item2_code: "", item2_content: "", item2_trouble: "", item2_level: "", item2_answer: "" },
      searchConfig: [
        {
          key: "site_type", label: "场所类型", type: "select", list: [
            { text: '出租屋', value: 'czw' },
            { text: '三小场所', value: 'sx' },
            { text: '其他场所', value: 'other' },
          ]
        },
        { key: "item1_code", label: "项目编号1", type: "input" },
        {
          key: "item1_content", label: "检测内容", type: "select", list: [
            { text: '低压配电和控制电器', value: '低压配电和控制电器' },
            { text: '低压配电柜（屏、台、箱、盘）', value: '低压配电柜（屏、台、箱、盘）' },
            { text: '插座与照明开关', value: '插座与照明开关' },
            { text: '剩余电流保护装置', value: '剩余电流保护装置' },
            { text: '配电线路', value: '配电线路' },
            { text: '照明器具', value: '照明器具' },
            { text: '空调器具', value: '空调器具' },
            { text: '接地装置', value: '接地装置' },
            { text: '接地和等电位联结', value: '接地和等电位联结' }
          ]
        },
        { key: "item2_code", label: "项目编号2", type: "input" },
        { key: "item2_content", label: "标准依据", type: "input" },
        { key: "item2_trouble", label: "隐患", type: "input" },
        {
          key: "item2_level", label: "隐患等级", type: "select", list: [
            { text: 'A', value: 'A' },
            { text: 'B', value: 'B' },
            { text: 'C', value: 'C' }
          ]
        },
        { key: "item2_answer", label: "整改建议", type: "input" }
      ],
      addModel: {
        addShow: false,
        site_type: '',
        item2_code: '',
        item2_trouble: '',
        item2_level: '',
        item2_answer: '',
      },
    };
  },
  computed: {
    ...mapGetters(['hasPermission']),
  },
  methods: {
    //初始化新增对话框
    initModel(modelType) {
      if (modelType === 'add') {
        this.addModel.addShow = false
        this.addModel.item2_code = ''
        this.addModel.item2_trouble = ''
        this.addModel.item2_level = ''
        this.addModel.item2_answer = ''
      }
    },
    //新增
    handleAdd() {
      this.addModel.addShow = true
    },
    async onAdd() {
      try {
        let params = {
          site_type: this.addModel.site_type,
          item2_code: this.addModel.item2_code,
          item2_trouble: this.addModel.item2_trouble,
          item2_level: this.addModel.item2_level,
          item2_answer: this.addModel.item2_answer,
        }
        await this.$Api.post('zg_trouble', params)
        this.$message.success('新增成功')
        this.initModel('add')
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onAddClose() {
      this.initModel('add')
    },
    //删除
    async handleDelete(row) {
      try {
        await this.$Api.post('del_zg_trouble', { id: row.id })
        this.$message.success('删除成功')
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.query = {
        employee_name2: "",
        account: "",
        mobile: "",
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("zg_trouble", { params: params });

        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>
